import { Pipe, PipeTransform } from '@angular/core';
import {TariffSize} from "../../../../../tariff";

@Pipe({
  name: 'indexToTariffSize',
  standalone: true
})
export class IndexToTariffSizePipe implements PipeTransform {

  transform(index: 0 | 1 | 2 | number): TariffSize {
    switch (index) {
      case 1:
        return 'comfort';
      case 2:
        return 'premium';
      default:
        return 'basic';
    }
  }

}
